import { render, staticRenderFns } from "./Pricing4.vue?vue&type=template&id=126e8a0c&"
import script from "./Pricing4.vue?vue&type=script&lang=js&"
export * from "./Pricing4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports